const NavigationHamburger = ({ open, toggleMenu }) => (
  <div className="ham-section">
    <button
      type="button"
      className={`ham-menu${open ? " open" : ""}`}
      aria-label={open ? "Close menu" : "Open menu"}
      aria-expanded={open}
      onClick={toggleMenu}
    >
      <span className="ham-bar" aria-hidden="true" />
      <span className="ham-bar" aria-hidden="true" />
      <span className="ham-bar" aria-hidden="true" />
    </button>
  </div>
);

export default NavigationHamburger;
